var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"ActionPanel"},[_c('header',[_c('h1',{staticClass:"title font-size-big"},[_vm._v(_vm._s(_vm.title))]),_vm._t("actions")],2),_c('div',{staticClass:"fields"},[_vm._t("default")],2)])}
var staticRenderFns = []

export { render, staticRenderFns }